<template>
  <v-container>
    <v-row id="top">
      <v-col>

        <v-row>
          <v-col>
            <h1 class="display-2">Help!</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
        <ul>
          <li>
            <a href="#character">Character Sheet</a>
          </li>

          <li>
            <a href="#footer">Footer Buttons</a>
          </li>

          <li>
            <a href="#progress">Vows and Progress Tracks</a>
          </li>

          <li>
            <a href="#momentum">Momentum</a>
          </li>

          <li>
            <a href="#log">Log</a>
          </li>

          <li>
            <a href="#action">Action Menu: Moves, Oracles, Rolls</a>
          </li>

          <li>
            <a href="#session">Sessions, Saving/Loading</a>
          </li>
        </ul>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col cols="12" id="character" class="heading-1">
            <h1>Character Sheet</h1>
          </v-col>
          <v-col cols="12">
            Click the arrow button in the bottom-right to open up the character
            sheet:

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img
                  class="text-center"
                  src="images/character-sheet-open.png"
                  max-width="200"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            This is where you'll set and increment/decrement all your stats as
            well as access Bonds, Assets, Progress, and other
            character-sheet-relevant details.

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/character-sheet.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>
          </v-col>

          <v-col>
          <a href="#top">Back to Top</a>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col cols="12" id="footer" class="heading-1">
            <h1>Footer Buttons</h1>
          </v-col>

          <v-col cols="12">
            The icons in the footer will perform rolls against the selected stat. The momentum icon will 'Burn' momentum <em>(momentum burning in the footer is currently broken. do this through the character sheet)</em>.

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/footer.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

          <p>
          <ul>
            <li><v-icon color="blue">mdi-run-fast</v-icon> Edge</li>
            <li><v-icon color="red">mdi-heart</v-icon> Heart</li>
            <li><v-icon color="grey darken-2">mdi-dumbbell</v-icon> Iron</li>
            <li><v-icon color="black">mdi-ninja</v-icon> Shadow</li>
            <li><v-icon color="pink lighten-2">mdi-brain</v-icon> Wits</li>
            <li><v-icon color="green">mdi-bottle-tonic-plus-outline</v-icon> Health</li>
            <li><v-icon color="purple">mdi-ghost</v-icon> Spirit</li>
            <li><v-icon color="brown">mdi-bag-personal-outline</v-icon> Supply</li>
            <li><v-icon color="orange">mdi-fire</v-icon> Momentum</li>
          </ul>
          </p>

          </v-col>

          <v-col>
          <a href="#top">Back to Top</a>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col cols="12" id="progress" class="heading-1">
            <h1>Vows and Progresss Tracks</h1>
          </v-col>

          <v-col cols="12">
            Vows and Progress Tracks are found in the 'PROGRESS' tab of the character sheet.

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/progress-tab.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            You can add tracks to the 'Vows' or 'Progress' section. They both work the same - the division is just for organization at the moment.

            Click the 'ADD' button to create a new track.

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/new-progress.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            Anywhere you see a progress track, you'll have easy-access to some of these controls:


            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/progress-detail.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            <ul>
              <li>
                <v-icon color="orange">mdi-pin</v-icon> The pin allows you to keep this track visible at all times (see below)
              </li>
              <li>
                <v-icon>mdi-note</v-icon> Quickly access the notes for this track
              </li>
              <li>
                <v-icon>mdi-pencil</v-icon> Edit the Name, Rank, and Notes for this track.
              </li>
              <li>
                <v-icon>mdi-delete</v-icon> Delete the track (permanently!)
              </li>
              <li>
                <v-icon>mdi-minus</v-icon> <v-icon>mdi-plus</v-icon> Remove or Add ticks to the track. The rank of the track does nothing automatic - it is only present for your reference. You must add each tick individually, regardless of rank.
              </li>
            </ul>

            When a track is pinned, it will remain in the app header at all times. This is very useful during a battle or scene challenge:

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/pinned-track.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            Click the <v-icon color="orange">mdi-close-circle-outline</v-icon> icon to un-pin the track (it won't be deleted! Just goes back into the 'PROGRESS' tab).

          </v-col>

          <v-col>
          <a href="#top">Back to Top</a>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col cols="12" id="momentum" class="heading-1">
            <h1>Momentum</h1>
          </v-col>

          <v-col cols="12">
            Found in the character sheet. Open up the 'Momentum Tools' expander to change the Max and Reset values as well as to 'Burn' momentum.

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/momentum-tools.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>
          </v-col>

          <v-col>
          <a href="#top">Back to Top</a>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col cols="12" id="log" class="heading-1">
            <h1>Log</h1>
          </v-col>

          <v-col cols="12">
            All Moves, Oracles, Rolls and user text-entries appear in the main Log. Clicking the <v-icon>mdi-close-circle-outline</v-icon> near the timestamp will allow you to delete an entry. Since very little is automated, you can delete and re-enter / redo moves as you like. The app doesn't police your game.

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/log.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

          <p>
          Create text entries for narrative bits, for notes, to add an addendum to a prior move; whatever you want. Use the 'New Entry' field at the bottom of the log, hitting <span><code>Enter</code></span> or clicking the green button to submit.
          </p>

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/small-entry.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            <p>
            You can optionally expand the entry field in order to write a lot more or just see more at once. Do this by either clicking the <v-icon>mdi-arrow-expand</v-icon> icon or by pressing <code>Ctrl + Space</code>. Once in the full-screen field, minimize it with <code>Ctrl + Space</code> again, or by clicking the <v-icon>mdi-close</v-icon> or submit with the "LOG" button or by pressing <code>Ctrl + Enter</code>
            </p>

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/large-entry.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            <p>
            So:
            <ul>
              <li>In small-mode, submit with <code>Enter</code></li>
              <li>In large-mode, submit with <code>Ctrl + Enter</code></li>
              <li>In any mode, toggle mode with <code>Ctrl + Space</code></li>
            </ul>
            </p>
          </v-col>

          <v-col>
          <a href="#top">Back to Top</a>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col cols="12" id="action" class="heading-1">
            <h1>Action Menu</h1>
          </v-col>

          <v-col cols="12">

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/action-menu.png" max-width="100">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            <p>
              The action menu in the top-right has buttons to access
              <ul>
                <li>Moves</li>
                <li>Oracles</li>
                <li>Generic challenge roll</li>
                <li class="text--disabled">World Map (coming soon)</li>
                <li class="text--disabled">General Notes (coming soon)</li>
              </ul>
            </p>

          </v-col>

          <v-col>
          <a href="#top">Back to Top</a>
          </v-col>
        </v-row>

        <v-divider />

        <v-row>
          <v-col cols="12" id="session" class="heading-1">
            <h1>Sessions, Saving/Loading</h1>
          </v-col>

          <v-col cols="12">

            <p>
            For now, your game session is entirely local to the device on which you are playing it. There are plans for the near-future to allow for sharing sessions across devices.
            </p>
            
            <p>
            You'll find a Save/Load option in the main nav menu:
            </p>

            <v-row justify="center" align="center">
              <v-spacer />
              <v-col>
                <v-img src="images/side-menu.png" max-width="300">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-spacer />
            </v-row>

            Click on that to open up the session dialog.

            <v-row justify="center" align="center">
              <v-spacer />
                <v-col>
                  <v-img src="images/save-load.png" max-width="300">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                        >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                          ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-col>
                <v-spacer />
            </v-row>

            <p>
            <ul>
              <li>The 'Load Session' dropdown has a list of all the sessions you've started on this device. Choose one and click "LOAD" to switch to that session.</li>
              <li>The 'New Session' field allows you to choose a title for a new session and "CREATE" to start a new game with that title.</li>
              <li>The 'Current Session Code' is just a reminder of the title for the current session you are playing. You can also find this in the URL bar of your browser <code>session=ironsworn_my_session</code></li>
              <li><strong>Note:</strong> <code>ironsworn_</code> will get automatically prepended to whatever title you choose. This is mostly irrelevant for the user's purposes, but you may notice that.</li>
            </ul>
            </p>

            <p class="text--disabled">
              For those who want to get technical, the "session" is a key in browser localstorage that saves all the relevant pieces of Vuex state. When you visit the site, the app checks the URL for the session key and sets up the Vuex state based on the contents of the localstorage key. As you do anything in the app, the Vuex state is updated and the localstorage item is updated simultaneously.
            </p>

          </v-col>

          <v-col>
          <a href="#top">Back to Top</a>
          </v-col>
        </v-row>

        <v-divider />

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        sections: [
          {
            title: 'Test',
            anchor: 'test',
          },
          {
            title: 'Test One',
            anchor: 'test1',
          },
          {
            title: 'Test two',
            anchor: 'test2',
          },
          {
            title: 'Test Three',
            anchor: 'test3',
          },
        ],
      };
    },
  };
</script>
